import React, { useState, useEffect } from "react";

import {
    Box,
    Button,
    TextField,
    Grid,
    styled,
    Card,
} from '@mui/material';

import { useFormik } from 'formik';

import CommonSectionHeader from "../../../common/CommonSectionHeader"
import { useAppContextFeatures } from '../../../../context/AppContext';

import { useSettings, defaultTypes, defaultSettings, getCreatePayload, getListFilters } from "../../../../hooks/api/useSettings";
import { useTranslations } from '../../../../hooks/useTranslations';
import { useSystemPrompt } from "../../../../hooks/useSystemPrompt";

import {
    initialValues,
    validationSchema,
} from "../../../../schema/setting/sms/ismsSchema"

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

const RenderForm = ({
    values,
    handleChange,
    errors,
    touched,
}) => {
    return (
        <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={3} sx={{ mt: 1 }}>
                <CommonSectionHeader
                    title={"Endpoint URL"}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={9}>
                <TextField
                    margin="dense"
                    size="small"
                    autoFocus
                    fullWidth
                    name={"endpointUrl"}
                    type="text"
                    variant="outlined"
                    placeholder={'https://www.isms.com.my/isms_send_all_id.php'}
                    value={values?.endpointUrl}
                    onChange={handleChange}
                    error={touched.endpointUrl && Boolean(errors.endpointUrl)}
                    helperText={touched.endpointUrl && errors.endpointUrl}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={3} sx={{ mt: 1 }}>
                <CommonSectionHeader
                    title={"Username"}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={9}>
                <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={"username"}
                    type="text"
                    variant="outlined"
                    value={values?.username}
                    onChange={handleChange}
                    error={touched.username && Boolean(errors.username)}
                    helperText={touched.username && errors.username}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={3} sx={{ mt: 1 }}>
                <CommonSectionHeader
                    title={"Password"}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={9}>
                <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={"password"}
                    type="text"
                    variant="outlined"
                    value={values?.password}
                    onChange={handleChange}
                    error={touched.password && Boolean(errors.password)}
                    helperText={touched.password && errors.password}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={3} sx={{ mt: 1 }}>
                <CommonSectionHeader
                    title={"Type"}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={9}>
                <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={"type"}
                    type="text"
                    variant="outlined"
                    placeholder={'1'}
                    value={values?.type}
                    onChange={handleChange}
                    error={touched.type && Boolean(errors.type)}
                    helperText={touched.type && errors.type}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={3}>
                <CommonSectionHeader
                    title={"Send ID"}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={9}>
                <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={"sendId"}
                    type="text"
                    variant="outlined"
                    placeholder={'63001'}
                    value={values?.sendId}
                    onChange={handleChange}
                    error={touched.sendId && Boolean(errors.sendId)}
                    helperText={touched.sendId && errors.sendId}
                />
            </Grid>

        </Grid>
    )
}

export default function ISMSSetting({
    routeType
}) {

    const { t } = useTranslations({ ns: ["common", "@user", "sidebar"] })

    const { promptMessage } = useSystemPrompt();
    const { setSystemLoading } = useAppContextFeatures()

    const { create, list } = useSettings(defaultTypes.sms_gateway.id);

    const [savedValues, setSavedValues] = useState(initialValues)

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try {

            let propsData = [
                {
                    key: defaultSettings.sms_gateway.isms.props.endpointUrl,
                    value: currentValues.endpointUrl,
                    label: "xx"
                },
                {
                    key: defaultSettings.sms_gateway.isms.props.username,
                    value: currentValues.username,
                    label: "xx"
                },
                {
                    key: defaultSettings.sms_gateway.isms.props.password,
                    value: currentValues.password,
                    label: "xx"
                },
                {
                    key: defaultSettings.sms_gateway.isms.props.type,
                    value: currentValues.type,
                    label: "xx"
                },
                {
                    key: defaultSettings.sms_gateway.isms.props.sendId,
                    value: currentValues.sendId,
                    label: "xx"
                },
            ]
    
            let loadInfo = getCreatePayload({
                typeId: defaultTypes.sms_gateway.id,
                typeName: "",
                settingId: defaultSettings.sms_gateway.isms.id,
                settingName: '',
                props: propsData
            })
    
            let data = {
                settings: [loadInfo]
            }

            const response = await create({ data });

            console.log('response', response)

            promptMessage(true, `Settings Saved`)

        } catch (error) {

            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const fetchCurrentSettings = async () => {

        setSystemLoading(true)

        try {

            let filterValues = getListFilters({
                typeKey: defaultTypes.sms_gateway.key,
                settingKey: defaultSettings.sms_gateway.isms.key,
                // settingKeys: [],
                fieldKeys: [
                    defaultSettings.sms_gateway.isms.props.endpointUrl,
                    defaultSettings.sms_gateway.isms.props.username,
                    defaultSettings.sms_gateway.isms.props.password,
                    defaultSettings.sms_gateway.isms.props.type,
                    defaultSettings.sms_gateway.isms.props.sendId,
                ]
            })

            const props = {
                limit: -1,
                skip: 0,
                filterValue: filterValues,
                sortInfo: {
                    id: "id",
                    dir: -1
                },
            }

            const response = await list(props);

            if (response?.data?.settings) {
                let savedSettings = response.data.settings

                let _endpointUrl = ""
                let _username = ""
                let _password = ""
                let _type = ""
                let _sendId = ""

                savedSettings.forEach(i => {
                    if (i.field_key === defaultSettings.sms_gateway.isms.props.endpointUrl) {
                        _endpointUrl = i.field_value
                    }
                    if (i.field_key === defaultSettings.sms_gateway.isms.props.username) {
                        _username = i.field_value
                    }
                    if (i.field_key === defaultSettings.sms_gateway.isms.props.password) {
                        _password = i.field_value
                    }
                    if (i.field_key === defaultSettings.sms_gateway.isms.props.type) {
                        _type = i.field_value
                    }
                    if (i.field_key === defaultSettings.sms_gateway.isms.props.sendId) {
                        _sendId = i.field_value
                    }
                })

                setSavedValues({
                    ...initialValues,
                    endpointUrl: _endpointUrl,
                    username: _username,
                    password: _password,
                    type: _type,
                    sendId: _sendId,
                })
            }

            console.log('response', response)

            setFieldValue(`rows`, response)

        } catch (error) {

            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const formik = useFormik({
        initialValues: savedValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue } = formik;

    useEffect(() => {

        fetchCurrentSettings()

    }, [])

    return (
        <form onSubmit={formik.handleSubmit}>
            <StyledCard>

                <RenderForm
                    t={t}
                    values={values}
                    handleChange={handleChange}
                    errors={errors}
                    touched={touched}
                />

            </StyledCard>
            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                <Grid item md={12} textAlign={"right"}>
                    <Button
                        type="submit"
                        variant="contained"
                        sx={{
                            mt: 3,
                            mb: 2
                        }}
                    >
                        {t('saveChanges')}
                    </Button>
                </Grid>
            </Grid>
        </form>

    )
}